angular.module("UI8.services").service("LikeService", [
  "$http",
  "$window",
  function ($http, $window) {
    var likes = [],
      unlikes = [],
      loggedIn = false,
      // Like counts, by product id:
      //   counts  - the count the server returned for this person's last
      //             like/unlike (it already includes it)
      //   pending - +1/-1 while a like/unlike is on its way
      //   bases   - the count the card's own data shows (may be cached)
      //   seq     - so only the latest toggle's reply is applied
      counts = {},
      pending = {},
      bases = {},
      seq = {};

    function init() {
      if (!$window.UI8.loggedIn) return;

      // User logged in
      loggedIn = true;

      // Fetch
      return $http
        .get("/account/favorites?json=1", { cache: true })
        .then(function (res) {
          likes = res.data.favorites || [];
        })
        .catch(function () {
          likes = [];
        });
    }

    /**
     * The like count to show for a product. `base` is the count in the card's
     * own data. Once this person has liked/unliked it, the server's count from
     * that reply wins, so a like is never counted twice, whether the card's
     * data is cached (no like in it yet) or fresh (like already in it).
     */
    function likeCount(id, base) {
      id = String(id);
      if (base !== undefined && base !== null) bases[id] = Number(base) || 0;
      var n = counts.hasOwnProperty(id) ? counts[id] : bases[id] || 0;
      return Math.max(0, n + (pending[id] || 0));
    }

    /**
     * Older templates show `product.likes + getCountModifier(id)`
     */
    function getCountModifier(id) {
      id = String(id);
      return likeCount(id) - (bases[id] || 0);
    }

    function sendToggle(id, request, step) {
      seq[id] = (seq[id] || 0) + 1;
      var mine = seq[id];
      pending[id] = (pending[id] || 0) + step;

      request.then(
        function (res) {
          if (seq[id] !== mine) return; // a newer like/unlike is on its way
          var n = res && res.data && res.data.product_likes;
          if (typeof n === "number") {
            counts[id] = n;
            pending[id] = 0;
          }
          // No count in the reply (older server): keep the +1/-1, as before
        },
        function () {
          // Failed: keep the +1/-1 shown, as before
        }
      );
    }

    /**
     * Determine if user likes Product
     * @param  {String} _id Unique mongo key of product to check
     * @return {Number} The amount of likes per that _id
     */
    function isLiked(_id) {
      if (!loggedIn) {
        return;
      }

      return likes.filter(function (el) {
        return el === _id;
      }).length;
    }

    /**
     * Determine if user has unliked Product (Favorites page only)
     * @param  {String} _id Unique mongo key of product to check
     * @return {Number} The amount of likes per that _id
     */
    function unLiked(_id) {
      if (!loggedIn) {
        return;
      }

      return unlikes.filter(function (el) {
        if (!likes.length) {
          likes = ["null"];
          return $window.location.reload();
        }

        return el === _id;
      }).length;
    }

    /**
     * Like a product
     * @param  {String} _id Unique mongo key of product to check
     */
    function likeProduct(_id, isFavoritePage) {
      if (!loggedIn) {
        return;
      }

      if (isLiked(_id) > 0) {
        if (isFavoritePage) {
          unlikes.push(_id);
        }

        likes = likes.filter(function (el) {
          return el !== _id;
        });

        sendToggle(
          String(_id),
          $http.delete("/account/favorite/" + _id + "?json=1"),
          -1
        );

        return;
      }

      likes.push(_id);

      sendToggle(
        String(_id),
        $http.put("/account/favorite/" + _id + "?json=1"),
        1
      );
    }

    init();

    // Public API
    return {
      isLiked: isLiked,
      unLiked: unLiked,
      toggleLike: likeProduct,
      likeCount: likeCount,
      getCountModifier: getCountModifier,
    };
  },
]);
